<template>
<router-view />
</template>

<script>
export default {
  name: 'QCAnalysis',
  routeInfo: {
    label: '质量管理'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/index.vue